import { PUT_FAQ_ERROR, PUT_FAQ_START, PUT_FAQ_SUCCESS } from '../../types';

export default function put_faqs(state, action) {
  switch (action.type) {
    case PUT_FAQ_START:
      return { ...state };
    case PUT_FAQ_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_FAQ_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}